import { z } from 'zod';
import { TenantIdSchema } from './_primitives.js';

// JD-R demand components (Bakker & Demerouti 2007) — each normalized 0–1 by CF
export const LoadComponentsSchema = z.object({
  activeEscalations:       z.number().min(0),
  openExceptions:          z.number().min(0),
  recentTonePressure:      z.number().min(0).max(1),
  consecutiveFocusMinutes: z.number().min(0),
  interruptDensity:        z.number().min(0),
}).passthrough();

// Document ID = workerId. One doc per worker, overwritten on each computation.
// Firestore writes come exclusively from computeCognitiveLoad CF (Admin SDK).
// Client reads: subject worker only (request.auth.uid == workerId).
export const CognitiveLoadScoreSchema = z.object({
  workerId:              z.string().min(1),
  tenantId:              TenantIdSchema,
  currentLoad:           z.number().min(0).max(1),
  loadComponents:        LoadComponentsSchema,
  // Sonnentag (2003, 2018): micro-recovery window. null = not in cooldown.
  cooldownUntil:         z.union([z.string(), z.object({}).passthrough(), z.null()]),
  confidence:            z.number().min(0).max(1),
  lastComputedAt:        z.union([z.string(), z.object({}).passthrough()]),
  aegisDecisionTrailId:  z.string().nullable().optional(),
  softDeleted:           z.boolean().optional(),
}).passthrough();

/** @typedef {import('zod').infer<typeof CognitiveLoadScoreSchema>} CognitiveLoadScore */
